<template>
  <v-app>
    <website-sprite />
    <website-header />
    <base-view />
    <website-footer />
    <!-- 售前 AI 客服：官网访客（想开店的潜在客户）咨询，引导注册/试用 -->
    <presale-chat />
  </v-app>
</template>

<script>
  export default {
    name: 'BaseLayout',
    components: {
      WebsiteSprite: () => import('@/components/WebsiteSprite'),
      WebsiteHeader: () => import('@/layouts/website/Header'),
      BaseView: () => import('./View'),
      WebsiteFooter: () => import('@/layouts/website/Footer'),
      PresaleChat: () => import('@/components/PresaleChat'),
    },
    watch: {
      // 新官网页面（meta.ws）透明悬浮在首屏上，浅色首屏的（案例/帮助/价格）加 nav-solid；
      // 旧版页面（注册/模板市场/文章，无 meta.ws）没有深色首屏，导航改实心 + 文档流占位
      '$route.meta': {
        immediate: true,
        handler (meta) {
          if (typeof document === 'undefined') return
          const legacy = !(meta && meta.ws)
          document.body.classList.toggle('nav-solid', legacy || !!(meta && meta.navSolid))
          document.body.classList.toggle('nav-flow', legacy)
        },
      },
    },
  }
</script>
